$(() => {

    ///////////Accordion Menu/////////////
    let $accordionMenu = $(".accordion-cta")
    $accordionMenu.each(function () {
        let $this = $(this);
        $this.on("click", function () {
            let $accordionContent = $('.navigation__list');
            let panel = $this.next().find($accordionContent);
            if (!panel) return;
            if ($this.hasClass("active")) {
                $this.removeClass("active");
                $this.attr("aria-expanded", "false");
                $(panel).slideUp();
            } else {
                $this.addClass("active");
                $this.attr("aria-expanded", "true");
                $(panel).slideDown();
            }
        })
    });

    ///////////annimation banner footer/////////////
    const $contentAnimate =$("#content-footer-animate-scroll");
    for (let i = 0; i < 3; i++) {
        const $copycontent = $($contentAnimate).children().clone()
        $copycontent.find("a").attr({"tabindex": "-1", "aria-hidden" : "true" });
        $($copycontent).appendTo($contentAnimate);
    }


    // ///////////Active Item Menu/////////////
    const pathname = String(window.location.pathname);
    const $itemsMenu = $("li a.footer-menu-items");
    $itemsMenu.each(function () {
        let $this = $(this);
        let itemsMenuhref = String($this.prop('href'));
        if ((itemsMenuhref.includes(pathname) && pathname != "/" && pathname != "/en" && pathname != "/fr"))  {
            $this.addClass("is-active");
        } else {
            $this.removeClass("is-active");
        }
    });


    // ///////////Active Item Menu/////////////
    $('.btnChangeLang').on('click', function () {
        window.location.href = <string>$('.js-change-my-language').attr('href');
    });

});